import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './ContactCTA.css';
import bgImg from '../images/overlayimg.jpg';

const ContactCTA = () => {
  return (
    <section
      className="contact-cta-section"
      style={{
        backgroundImage: `linear-gradient(rgba(44,95,125,0.55), rgba(44,95,125,0.55)), url(${bgImg})`,
      }}
    >
      <Container>
        <div className="cta-card">
          <Row className="align-items-center">
            <Col md={8} className="cta-text">
              <h2>Get Trusted Home Care — We're Here 24/7</h2>
              <p>
                Personalized care plans, skilled professionals, and emergency support. Book a free consultation and
                we'll create a care plan tailored to your needs.
              </p>
            </Col>
            <Col md={4} className="cta-actions text-md-end text-center">
              <a
                href="https://wa.me/919361207761?text=Hi%2C%20I%20am%20interested%20in%20booking%20a%20home%20care%20consultation.%20Can%20you%20please%20share%20the%20next%20steps%20and%20available%20slots%3F"
                className="btn btn-cta"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Consultation
              </a>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default ContactCTA;
